import React, { useContext } from "react";
import { TestContext } from "../../context/test_context";
import { TestListContext, TestPageContext } from "../../scenes/tests";
import { toast } from "sonner";
import TestActionButtons from "../test/TestActionButtons";

export type TestControlButtonsType = {
  testgroup: any;
  testgroup_index: any;
};

export default function TestsControlButtons({
  testgroup,
  testgroup_index,
}: TestControlButtonsType) {
  const { deleteTestGroup, pauseTestGroup, restartTestGroup, stopTestGroup } =
    useContext(TestContext);
  const { testgroups, setTestGroups } = useContext(TestListContext);
  const { reload, setReload } = useContext(TestPageContext);

  const test_data = testgroup;

  if (!test_data) return null;

  const updateGroup = (updated: any) => {
    setTestGroups((prev: any[]) =>
      prev.map((g: any, i: number) => (i === testgroup_index ? updated : g))
    );
    setReload(!reload);
  };

  const handlePlayPause = async () => {
    toast.promise(pauseTestGroup(test_data.id), {
      loading: test_data.active ? "Pausing Test..." : "Resuming Test...",
      success: (resp: any) => {
        if (resp?.success) updateGroup(resp.testgroup);
        return test_data.active ? "Paused Test" : "Resumed Test";
      },
      error: test_data.active ? "Error Pausing Test" : "Error Resuming Test",
    });
  };

  const handleStop = async () => {
    toast.promise(stopTestGroup(test_data.id), {
      loading: "Stopping Test...",
      success: (resp: any) => {
        if (resp?.success) updateGroup(resp.testgroup);
        return "Stopped Test";
      },
      error: "Error Stopping Test",
    });
  };

  const handleRestart = async () => {
    toast.promise(restartTestGroup(test_data.id), {
      loading: "Restarting Test...",
      success: (resp: any) => {
        if (resp?.success) updateGroup(resp.testgroup);
        return "Restarted Test";
      },
      error: "Error Restarting Test",
    });
  };

  const handleDelete = async () => {
    const resp = await deleteTestGroup(test_data.id);
    if (resp?.success) {
      setTestGroups((prev: any[]) => prev.filter((_: any, i: number) => i !== testgroup_index));
      setReload(!reload);
    } else {
      toast.error("Delete failed. Please try again.");
    }
  };

  return (
    <TestActionButtons
      testgroup={test_data}
      onTogglePlayPause={handlePlayPause}
      onStop={handleStop}
      onRestart={handleRestart}
      onDelete={handleDelete}
    />
  );
}
